/**
 * Resolve the quiz V2 base route segment from the current path so shared V2 edit/results/attempt
 * components keep navigation within the namespace they were entered from (My Quizzes, Shared By Me,
 * or the super-admin Customer Quizzes V2 tab). Keeping links in-namespace lets the non-super-admin
 * route guard and tab highlighting in `Quizzes` work without special-casing.
 */
export const getQuizV2BasePath = (pathname: string): string => {
    if (pathname.includes('/quiz/my-quiz')) {
        return '/quiz/my-quiz';
    }
    if (pathname.includes('/quiz/shared-quiz')) {
        return '/quiz/shared-quiz';
    }
    return '/quiz/customer-quiz-v2';
};
